import utils from '@eitje/utils'
import {mdT as _mdT, parseT} from '@eitje/bridge'

// Known cases in which the text is not converted to string:
// 1. AdvancedTable, where TanStack's flexRender() returns

export const toString = ({children, t, mdT, countSuffix, debug}) => {
	let text
	if (mdT) {
		text = _.isArray(mdT) ? _mdT(...mdT) : _mdT(mdT)
	} else if (utils.exists(children)) {
		// Let 'children' always take precedence over 't'.
		text = children
	} else {
		text = parseT(t)
	}

	// Text is an array when multiple items are interpolated within accolades, for example:
	// <Text> {user.full_name} {user.active && 'active'} </Text>
	if (_.isArray(text)) {
		text = text
			.filter(Boolean)
			.map(child => toString({children: child}))
			.join('')
	}

	if (_.isNumber(text)) {
		text = text.toString()
	}

	if (countSuffix && _.isString(text)) {
		text = text.concat(` (${countSuffix})`)
	}

	// Allow semantic HTML <br/> breaks being passed to Text.
	if (text?.type === 'br') {
		text = '\n'
	}

	if (debug && text && !_.isString(text)) {
		console.log(text)
	}

	return text
}
